import React from 'react';

import type { ChatController } from '~/components/AiChat/controller/types';

const ChatControllerContext = React.createContext<ChatController | null>(null);

export const ChatControllerProvider: React.FC<React.PropsWithChildren<{ controller: ChatController }>> = ({
  controller,
  children,
}) => <ChatControllerContext.Provider value={controller}>{children}</ChatControllerContext.Provider>;

/**
 * The chat the components render, or null outside a ChatControllerProvider. A component that renders only
 * inside a chat passes `required: true`: a missing provider then throws in every environment, since the
 * component has nothing to render without one. App's ErrorBoundary reports the error to Sentry.
 */
export function useChatController(): ChatController | null;
export function useChatController(options: { required: true }): ChatController;
export function useChatController(options?: { required?: boolean }): ChatController | null {
  const controller = React.useContext(ChatControllerContext);
  if (options?.required && !controller) {
    throw new Error('useChatController: no ChatControllerProvider above this chat component');
  }
  return controller;
}
